// El filtro por categoría de Mi marca → Productos (ADR-2026-10-22-filtro-por-categoria-en-productos).
// Elegir una categoría muestra sus productos Y los de todas sus subcategorías: estar en "Oversize"
// es estar en "Remeras". Puro.
import { ramaDe, type CategoriaPlana } from '../pages/lanzamientos/arbolDeCategorias';

/** El filtro "Sin categoría": los productos que no tienen ninguna (o una que ya no existe). */
export const SIN_CATEGORIA = '__sin_categoria__';

export function filtrarPorCategoria<T>(
  items: T[],
  /** null = todas; `SIN_CATEGORIA`; o el id de una categoría. */
  filtro: string | null,
  categoriaDe: (item: T) => string | null | undefined,
  categorias: readonly CategoriaPlana[],
): T[] {
  if (!filtro) return items;
  const existentes = new Set(categorias.map((c) => c.id));
  if (filtro === SIN_CATEGORIA) {
    return items.filter((i) => {
      const c = categoriaDe(i);
      return !c || !existentes.has(c);
    });
  }
  const rama = ramaDe(categorias, filtro);
  return items.filter((i) => {
    const c = categoriaDe(i);
    return !!c && rama.has(c);
  });
}
